<template>
  <div>
    <div class="input-group input-group-sm medication-group">
      <multiselect v-if="allOptions.medication" :placeholder="'Medikamente filtern ...'" :options="allOptions.medication" v-model="chosenOptions.option" :multiple="true" />
    </div>
    <div class="input-group input-group-sm medication-group">
      <multiselect v-if="allOptions.substance" :placeholder="'Wirkstoffe filtern ...'" :options="allOptions.substance" v-model="chosenOptions.substance" :multiple="true" />
    </div>
    <div class="input-group input-group-sm medication-group">
      <multiselect v-if="allOptions.moa" :placeholder="'MoAs filtern ...'" :options="allOptions.moa" v-model="chosenOptions.moa" :multiple="true" />
    </div>
    <div class="input-group input-group-sm medication-group">
      <multiselect v-if="allOptions.effect" :placeholder="'Effekte filtern ...'" :options="allOptions.effect" v-model="chosenOptions.effect" :multiple="true" />
    </div>
    <b-btn class="btn btn-sm btn-block" @click="search(boxes)"> Anwenden </b-btn>
    <b-btn class="btn btn-sm btn-block" style="margin-top: 2px;" @click="deleteMedicalFilter(boxes)"> Filter zurücksetzen </b-btn>
  </div>
</template>

<script>
import filterMixins from './filter-mixins'
import api from '@/api'
import Multiselect from 'vue-multiselect'

export default {
  name: 'medical-filter',
  mixins: [filterMixins],
  data () {
    return {
      chosenOptions: {},
      allOptions: {}
    }
  },
  props: {
    boxes: Object
  },
  components: {
    Multiselect
  },
  created () {
    this.getFilterOptions()
  },
  methods: {
    search () {
      const { query } = this
      if (!Object.values(this.chosenOptions).length) {
        this.$set(query.assocFilters, 'medication', undefined)
      } else {
        this.$set(query.assocFilters, 'medication', this.chosenOptions)
      }
      this.$set(this.query, 'nChanges', this.query.nChanges + 1)
      this.query.offset = 0
      this.$set(this.boxes, this.field, false)
    },
    async getFilterOptions () {
      var options = await api.getMedicalFilterOptions()
      this.allOptions = options
    },
    setOptions () {
      var setFilters = this.query.assocFilters.medication
      var possibleFilters = ['option', 'substance', 'moa', 'effect']
      possibleFilters.forEach(fil => {
        this[fil] = (setFilters && setFilters[fil]) ? setFilters[fil] : ''
      })
    },
    deleteMedicalFilter (boxes) {
      this.chosenOptions = {}
      this.deleteFilter(boxes)
    }
  },
  watch: {
    'query.assocFilters': {
      handler () {
        this.chosenOptions = this.query.assocFilters.medication || {}
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/plugins/medicalFilter.vue